module.exports = __webpack_public_path__ + "botswana.svg?6e0028effb817b221f10a24e78e38bfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/botswana.svg
// module id = 116
// module chunks = 10